import { colors } from 'fitify-ui'
import { ButtonStyles } from 'fitify-ui-landing/src/components/Button/Button.Styles'
import { TextStyles } from 'fitify-ui-landing/src/components/Text'
import {
  biggerPhoneLandscape,
  biggerPhoneUp,
  phone,
} from 'fitify-ui-landing/src/theme/breakpoints'
import Link from 'next/link'
import styled, { css } from 'styled-components'

export const StyledHeader = styled.div`
  position: relative;
  width: 100%;

  ${phone(css`
    display: flex;
    height: calc(100% - 260px);
    flex-direction: column-reverse;
  `)};
`

type Props = {
  headlineVariant?: TextTypesVariants
}

export const StyledBusinessHeaderWrapper = styled.div<Props>`
  display: grid;
  width: 100%;
  max-width: 984px;
  height: 100%;
  align-items: center;
  margin-top: 80px;
  grid-auto-columns: 1fr;
  grid-gap: 24px;
  grid-template-columns: 0.85fr 1.15fr;
  grid-template-rows: 1fr;

  ${biggerPhoneLandscape(css`
    margin-top: 50px;
  `)};

  ${phone(css`
    display: flex;
    justify-content: center;
    margin-top: 0;
    grid-auto-columns: unset;
    grid-template-columns: unset;
    grid-template-rows: unset;
  `)};

  div {
    ${phone(css`
      &:first-child {
        width: inherit;
      }
    `)};
  }

  h1 {
    letter-spacing: -0.96px;
  }

  ${TextStyles} {
    &:not(:first-child) {
      max-width: 420px;
      margin-top: 16px;
      margin-bottom: 32px;
      ${biggerPhoneLandscape(css`
        max-width: 350px;
        margin-top: 16px;
        margin-bottom: 24px;
      `)};
      ${phone(css`
        max-width: 350px;
        margin-top: 0;
        margin-bottom: 24px;
      `)};
    }

    &:first-child {
      line-height: ${(props) =>
        props.headlineVariant && props.headlineVariant === 'condensed-title'
          ? '90%'
          : '110%'};
    }

    &:nth-child(2) {
      ${phone(css`
        max-width: 600px;
        margin-top: 25px;
        margin-bottom: 24px;
      `)};
    }

    &:nth-child(3) {
      ${phone(css`
        color: ${colors.Gray800};
      `)};
    }

    ${phone(css`
      max-width: 100%;
    `)};
  }

  ${ButtonStyles} {
    width: 100%;
    justify-content: center;

    ${biggerPhoneUp(css`
      width: fit-content;
      justify-content: flex-start;
      order: 0;
    `)};
  }
`

export const BusinessContactLink = styled(Link)`
  order: 5;
`

export const StyledBusinessHeaderWrapperContent = styled.div<Props>`
  position: relative;
  display: flex;
  height: 100%;
  flex-direction: column;

  ${ButtonStyles} {
    height: 56px;
    padding: 17px 32px;
    > span {
      font-size: 20px;
    }

    ${biggerPhoneLandscape(css`
      height: 48px;
      padding: 14.5px 28px;

      > span {
        font-size: 16px;
      }
    `)};

    ${phone(css`
      height: 48px;
      padding: 14.5px 0;

      > span {
        font-size: 16px;
      }
    `)};
  }
`

export const StyledMobileImage = styled.div`
  position: relative;
  margin: 19px 0 0;
  aspect-ratio: 16 / 9;

  img {
    border-radius: 24px;
  }
`

export const StyledImageContainer = styled.div`
  position: relative;
  overflow: hidden;

  img {
    border-radius: 24px;
  }
`
